export const LOAD_GRAVITY_FIELDS = 'gravity/LOAD_GRAVITY_FIELDS';
